import { AzureMediaPlayerComponent } from './azure-media-player.component';
import { MediaPlayerControlsComponent } from './media-player-controls.component';
import { TimelineComponent } from './timeline';
import { TimerProgressComponent } from './timer-progress.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { TimelineEventComponent } from './timeline-event';
import { ClipViewerComponent } from './clip-viewer';
import { CloneMatchButtonComponent } from './clone-match-button';
import { FavoriteMatchButtonComponent } from './favorite-match-button';

export const components: any[] = [
  AzureMediaPlayerComponent,
  MediaPlayerControlsComponent,
  TimelineComponent,
  TimerProgressComponent,
  VideoPlayerComponent,
  TimelineEventComponent,
  ClipViewerComponent,
  CloneMatchButtonComponent,
  FavoriteMatchButtonComponent
];

export * from './azure-media-player.component';
export * from './media-player-controls.component';
export * from './timeline';
export * from './timer-progress.component';
export * from './video-player/video-player.component';
export * from './timeline-event';
export * from './clip-viewer';
export { CloneMatchButtonComponent } from './clone-match-button';
export { FavoriteMatchButtonComponent } from './favorite-match-button';